import script from "./ComplaintsBook.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplaintsBook.vue?vue&type=script&setup=true&lang=js"

import "./ComplaintsBook.vue?vue&type=style&index=0&id=23ba5214&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23ba5214"]])

export default __exports__